<script lang="ts">
    import { translation } from "../../../stores.js";
    export let stream: MediaStream | null = null;
    export let mediaState;
    export let pointerPosition;
    export let showPointer = true;

    let videoEl: HTMLVideoElement;
    let pointerEl: HTMLImageElement;

    $: if (videoEl && stream) {
        videoEl.srcObject = stream;
    }

    $: if (pointerPosition && pointerEl && videoEl && showPointer) {
        const videoPos = videoEl.getBoundingClientRect();

        const left =
            videoPos.left +
            (pointerPosition.x * (videoPos.right - videoPos.left)) /
                pointerPosition.videoX -
            pointerEl.width / 2;

        const top =
            videoPos.top +
            (pointerPosition.y * (videoPos.bottom - videoPos.top)) /
                pointerPosition.videoY -
            pointerEl.height / 2;

        pointerEl.style.left = `${left}px`;
        pointerEl.style.top = `${top}px`;
        pointerEl.style.visibility = "visible";
    }
</script>

<div class="flex justify-center relative">
    {#if showPointer}
        <img
            bind:this={pointerEl}
            src="img/pointeur.png"
            alt="Red Pointer"
            width="10"
            height="10"
            style="visibility: hidden; position: absolute; z-index: 2;"
        />
    {/if}

    {#if mediaState?.videoPaused}
        <div class="video-overlay">
            {#if mediaState.videoPauseOrigin === "conseiller"}
                {translation.alert.cameraPausedAdvisor}
            {:else}
                {translation.alert.cameraPaused}
            {/if}
        </div>
    {/if}

    {#if mediaState?.audioMuted}
        <div class="audio-overlay">
            {#if mediaState.audioMuteOrigin === "conseiller"}
                {translation.alert.cameraMutedAdvisor}
            {:else}
                {translation.alert.cameraMuted}
            {/if}
        </div>
    {/if}

    <video
        bind:this={videoEl}
        class='local-video'
        autoplay
        playsinline
        muted
    ></video>
</div>

<style>
    .video-overlay,
    .audio-overlay {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: rgba(0, 0, 0, 0.65);
        color: white;
        padding: 12px 18px;
        border-radius: 10px;
        font-weight: 600;
        z-index: 5;
        text-align: center;
    }
    .local-video {
        width: 70%;
        max-width: 800px;
        max-height: 80vh;
        border-radius: 8px;
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);
        /* object-fit: contain; */
    }

    @media (max-width: 768px) {
        .local-video {
            width: 100%;
            max-height: 60vh;
        }
    }
</style>
